// extracted by mini-css-extract-plugin
export var baseButton = "_qk-0";
export var controlsArrowKeys = "_qk-1";
export var controlsResetButton = "_qk-2";
export var lightGameButton = "_qk-4 _qk-0";
export var playAgainButton = "_qk-5 _qk-0";
export var startGameButton = "_qk-3 _qk-0";